import React, {ReactNode, useState} from 'react';
import {PageWrapper} from "../../../components/UI/PageWrapper/PageWrapper";
import {CustomCard} from "../../../components/UI/AntCustom/CustomCard";
import {PlaneApprovalTabPane} from "./components/PlaneApprovalTabPane";
import {defineMessages, useIntl} from "react-intl";


const PlaneApprovalsPageMessages = defineMessages({
  pending: {
    id: "planeApprovalsPage.pending",
    defaultMessage: "Pending registrations",
  },
  processed: {
    id: "planeApprovalsPage.processed",
    defaultMessage: "Processed registrations",
  },
  title: {
    id: "planeApprovalsPage.title",
    defaultMessage: "Aircraft approvals",
  }
})

enum PlaneApprovalsTabKeysEnum {
  PENDING = 'pending',
  PROCESSED = 'processed',
}

interface IContentList {
  pending: ReactNode;
  processed: ReactNode;
}

export const PlaneApprovalsPage = () => {
  const intl = useIntl();
  const [activeTabKey, setActiveTabKey] = useState<PlaneApprovalsTabKeysEnum>(PlaneApprovalsTabKeysEnum.PENDING);

  const tabList = [
    {key: PlaneApprovalsTabKeysEnum.PENDING, tab: intl.formatMessage(PlaneApprovalsPageMessages.pending)},
    {key: PlaneApprovalsTabKeysEnum.PROCESSED, tab: intl.formatMessage(PlaneApprovalsPageMessages.processed)},
  ];

  const contentList: IContentList = {
    pending: <PlaneApprovalTabPane isPending={true} />,
    processed: <PlaneApprovalTabPane isPending={false} />,
  };

  return (
    <PageWrapper>
      <CustomCard title={intl.formatMessage(PlaneApprovalsPageMessages.title)} width={'max'} tabList={tabList} onTabChange={(key: string) => {
        setActiveTabKey(key as PlaneApprovalsTabKeysEnum)
      }}>
        {contentList[activeTabKey as keyof typeof contentList]}
      </CustomCard>
    </PageWrapper>
  );
};

